import { theme } from "@/config/theme";
import React, { useState } from "react";
import styled from "styled-components";

interface CollapseItem {
    key: string;
    label: string;
    children: React.ReactNode | string;
}

interface CollapsibleProps {
    items: CollapseItem[];
    defaultOpenKeys?: string[];
}

const CollapsibleContainer = styled.div`
    margin: 10px 0;
    overflow: hidden;
    border-bottom: 1px dotted #ddd;
    color: ${theme["color-grey"]};
`;

const Header = styled.div`
    padding: 10px 15px;
    cursor: pointer;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1f1c1b;

    &:hover {
        background-color: #e6e6e6;
    }
`;

const Icon = styled.span`
    font-size: 1.2em;
    // font-weight: bold;
    color: ${theme["color-blue"]};
`;

const Content = styled.div<{ isOpen: boolean }>`
    padding: 15px;
    background-color: #fff;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
`;

const Collapsible: React.FC<CollapsibleProps> = ({
    items,
    defaultOpenKeys = []
}) => {
    const [openKeys, setOpenKeys] = useState<string[]>(defaultOpenKeys);

    const toggleItem = (key: string) => {
        setOpenKeys((prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key)
                : [...prevKeys, key]
        );
    };

    return (
        <>
            {items.map((item) => (
                <CollapsibleContainer key={item.key}>
                    <Header onClick={() => toggleItem(item.key)}>
                        {item.label}
                        <Icon>{openKeys.includes(item.key) ? "−" : "+"}</Icon>
                    </Header>
                    <Content isOpen={openKeys.includes(item.key)}>
                        {typeof item.children === "string" ? (
                            <p>{item.children}</p>
                        ) : (
                            item.children
                        )}
                    </Content>
                </CollapsibleContainer>
            ))}
        </>
    );
};

export default Collapsible;
